import type { TableCellProps } from "@mui/material";
import clsx from "clsx";
import type React from "react";
import { useMemo } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { TableCellLinkContainer, classes } from "./styles";

interface ITableCellLinkProps {
  to: string;
  openNewTab?: boolean;
  isAuthorized?: boolean;
  cellPadding: number | string;
  children: React.ReactNode;
  TableCell?: TableCellProps;
  Link?: Omit<LinkProps, "to" | "target" | "rel">;
}

export const TableCellLink = ({
  to,
  openNewTab,
  isAuthorized,
  cellPadding,
  TableCell: TableCellProps,
  Link: LinkProps,
  children,
}: ITableCellLinkProps) => {
  const linkProps: LinkProps = useMemo(() => {
    const props: LinkProps = { to };
    if (openNewTab) {
      props.target = "_blank";
      props.rel = "noopener noreferrer";
    }
    return props;
  }, [to, openNewTab]);

  return (
    <TableCellLinkContainer
      {...TableCellProps}
      className={clsx(classes.cell, TableCellProps?.className)}
      cellPadding={cellPadding}
    >
      <Link
        {...LinkProps}
        {...linkProps}
        className={clsx(classes.link, LinkProps?.className)}
        style={{ ...LinkProps?.style, pointerEvents: isAuthorized === false ? "none" : "unset" }}
      >
        {children}
      </Link>
    </TableCellLinkContainer>
  );
};
